import { useAuth } from "@/hooks/useAuth";
import Header from "@/organisms/header";
import { Outlet } from "react-router-dom";
import { style } from "./style";

export default function AuthenticatedLayout() {
  const isAuthenticated = useAuth();

  return (
    isAuthenticated && (
      <>
        <Header />
        <main style={style}>
          <Outlet />
        </main>
      </>
    )
  );
}
